import React, { ComponentType } from 'react';
import PaddingBox from '@uds/padding-box';
import { Container } from '@uds/grid';
import { Heading02, Heading04 } from '@uds/typography';
import Shortcode, { ShortcodeProps } from 'components/Shortcode';
import Ribbon from 'components/ribbons/Ribbon';
import CallToAction from 'components/common/CallToAction';
import { useBreakpoints } from '@ux/responsive';
import visibilitySet from 'presentation/hocs/visibilitySet';
import errorBoundary from 'presentation/hocs/errorBoundary';
import { RibbonProps, Type } from 'domain/constants/ribbons';
import { CTA } from 'core/ribbons/cta';
import { isNilOrEmpty } from 'presentation/utils/generalUtils';
import findResponsiveItem from 'presentation/utils/findResponsiveItem';
import { Alignment } from 'domain/constants/alignment';

import getClassNames from './Info.stylesheet';

interface OuterProps extends RibbonProps {
  title: ShortcodeProps;
  subtitle: ShortcodeProps;
  ctas: Array<CTA>;
}

export const Info = ({ id, loading, name, title, subtitle, ctas, colorway, hBaseline = 1, layout }: OuterProps) => {
  const hasTitle = !isNilOrEmpty(title);
  const hasSubtitle = !isNilOrEmpty(subtitle);
  const hasCta = !isNilOrEmpty(ctas);
  const { isMinSm } = useBreakpoints();

  const alignment = findResponsiveItem(useBreakpoints(), [
    layout?.alignmentMobile ?? Alignment.STARTING,
    layout?.alignmentTablet ?? Alignment.STARTING,
    layout?.alignment ?? Alignment.STARTING,
  ]);

  const classNames = getClassNames({
    alignment,
  });
  return (
    <Ribbon id={id} colorway={colorway} loading={loading} layout={layout} name={name} type={Type.INFO}>
      <div className={classNames.root}>
        <Container>
          <PaddingBox>
            {hasTitle && (
              <Heading02 depth={hBaseline}>
                <Shortcode against={colorway} code={title} />
              </Heading02>
            )}
            {hasSubtitle && (
              <Heading04 component="p" className={classNames.subtitle}>
                <Shortcode against={colorway} code={subtitle} />
              </Heading04>
            )}
            {hasCta && (
              <div className={classNames.ctas}>
                {ctas.map((cta, i) => (
                  <div key={`info.cta.${id}.`.concat(String(i))} className={classNames.cta}>
                    <CallToAction ribbonId={id} index={i} block={!isMinSm} {...cta} />
                  </div>
                ))}
              </div>
            )}
          </PaddingBox>
        </Container>
      </div>
    </Ribbon>
  );
};

Info.displayName = 'Info';

export default errorBoundary(visibilitySet(Info)) as ComponentType<OuterProps>;
